module.exports = __webpack_public_path__ + "img/funnel-fuel-logo.ead3c31d.png";